import React from "react";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";

const MINUTES_PER_DAY = 24 * 60;
const MINUTES_PER_HOUR = 60;

// The backend stores each reminder offset as a single minutes value. We keep
// that as the source of truth and only split it into days/hours/minutes for the
// UI, so "5 days before" no longer means typing 7200.
const toParts = (totalMinutes) => {
  const total = parseInt(totalMinutes, 10);
  if (!total || total < 0 || Number.isNaN(total)) {
    return { days: "", hours: "", minutes: "" };
  }
  return {
    days: Math.floor(total / MINUTES_PER_DAY),
    hours: Math.floor((total % MINUTES_PER_DAY) / MINUTES_PER_HOUR),
    minutes: total % MINUTES_PER_HOUR,
  };
};

const toTotalMinutes = ({ days, hours, minutes }) =>
  (parseInt(days, 10) || 0) * MINUTES_PER_DAY +
  (parseInt(hours, 10) || 0) * MINUTES_PER_HOUR +
  (parseInt(minutes, 10) || 0);

export const NotificationReminder = ({
  displayMode,
  timeBeforeEnd,
  setTimeBeforeEndFilling,
  notification,
  setNotification,
  timesToSend,
  setTimesToSend,
}) => {
  const handlePartChange = (index, part, rawValue) => {
    if (rawValue !== "" && !(rawValue >= 0)) return;
    const nextParts = {
      ...toParts(timeBeforeEnd && timeBeforeEnd[index]),
      [part]: rawValue,
    };
    const tmpArray = [...timeBeforeEnd];
    tmpArray[index] = toTotalMinutes(nextParts);
    setTimeBeforeEndFilling(tmpArray);
  };

  return (
    <Grid>
      <Typography variant="h6" gutterBottom>
        Ustawienia powiadomień przed końcem wypełniania
      </Typography>
      <Box p={1}>
        <Box mt={1}>
          <Grid item xs={3}>
            <TextField
              id="outlined-number"
              label="Ilość powiadomień"
              type="text"
              variant="outlined"
              size="small"
              inputProps={{ min: 0, inputMode: "numeric", pattern: "[0-9]*" }}
              disabled={displayMode}
              value={timesToSend}
              onChange={(e) => {
                if (e.target.value >= 0) {
                  setTimesToSend(e.target.value);
                }
              }}
            />
          </Grid>
        </Box>

        <hr />
        <>
          {timesToSend &&
            [...Array(parseInt(timesToSend))].map((e, index) => {
              return (
                <Box m={2} key={index}>
                  <Grid item xs={3}>
                    <Typography variant="h6" gutterBottom>
                      {`Powiadomienie: ${index + 1}`}
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography variant="caption" color="textSecondary">
                      Ile czasu przed upłynięciem daty wypełnienia ma przyjść
                      powiadomienie
                    </Typography>
                    <Grid container spacing={1}>
                      {[
                        { part: "days", label: "Dni" },
                        { part: "hours", label: "Godziny" },
                        { part: "minutes", label: "Minuty" },
                      ].map(({ part, label }) => (
                        <Grid item xs={4} key={part}>
                          <TextField
                            disabled={displayMode}
                            label={label}
                            type="text"
                            variant="outlined"
                            size="small"
                            inputProps={{
                              min: 0,
                              inputMode: "numeric",
                              pattern: "[0-9]*",
                            }}
                            value={
                              toParts(timeBeforeEnd && timeBeforeEnd[index])[
                                part
                              ]
                            }
                            onChange={(e) =>
                              handlePartChange(index, part, e.target.value)
                            }
                            fullWidth
                          />
                        </Grid>
                      ))}
                    </Grid>
                  </Grid>
                  <br />
                  <Grid item xs={3}>
                    <TextField
                      disabled={displayMode}
                      label="Treść powiadomienia"
                      multiline
                      variant="outlined"
                      rows={2}
                      rowsMax={4}
                      fullWidth
                      value={(notification && notification[index]) || ""}
                      onChange={(e) => {
                        let tmpArray = [...notification];
                        tmpArray[index] = e.target.value;
                        setNotification(tmpArray);
                      }}
                    />
                  </Grid>
                  <hr />
                </Box>
              );
            })}
        </>
        {/* <Box mt={1}>
          <Grid item xs={3}>
            <TextField
              label="Treść powiadomienia"
              multiline
              variant="outlined"
              rows={2}
              rowsMax={4}
              fullWidth
              value={smsNotification}
              onChange={(e) => setSmsNotification(e.target.value)}
            />
          </Grid>
        </Box> */}
      </Box>
    </Grid>
  );
};
